import type { IconSvgObject } from './types';

const ChartDecreaseIcon: IconSvgObject = [
  ["path", { d: "M21 21H3V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 6C10.5 6 17.5 7.5 17.5 17M19.5 14.5L17.5 17L15 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartDecreaseIcon;
